import React, { useMemo } from 'react';

import Input from '../../../../../../../../../common/data-entry/Input';
import Select from '../../../../../../../../../common/data-entry/Select';
import { countries, getCountryById } from '../../../../../../../../../services/geo';
import { formatDialCode, normalizePhoneNumber } from '../../../../../../../../../services/geo/e-164';
import { caseInsensitiveStringIncludes } from '../../../../../../../../../services/string';

import './PhoneNumberInput.scss';

export default function PhoneNumberInput({ label, name, value, onChange, validationMessage, required }) {
  const { countryId = '', nationalNumber = '' } = value || {};

  const matchedCountry = useMemo(() => {
    return getCountryById(countryId) || { id: null };
  }, [countryId]);

  return (
    <div className="pcd-phone-number-input">
      <Select
        label="Country"
        customOptionTemplateFunction={customOptionTemplateFunction}
        customSelectedValueTemplateFunction={customSelectedValueTemplateFunction}
        clearSearchOnSelection={true}
        searchable
        value={matchedCountry}
        onChange={handleCountryChange}
        clearable={false}
        deselectOnSelectedOptionClick={false}
        dataSource={countries}
        customFilterFunction={customFilterFunction}
        required={required}
      />
      <Input
        label={label}
        name={name}
        prefix={formatDialCode(matchedCountry?.dialCode)}
        value={nationalNumber}
        onChange={handleInputChange}
        validationMessage={validationMessage}
        required={required}
        disabled={!countryId}
      />
    </div>
  );

  function handleInputChange({ target }) {
    if (!countryId) {
      return;
    }
    onChange({
      name,
      countryId,
      nationalNumber: normalizePhoneNumber(target.value, countryId)
    });
  }

  function handleCountryChange(country) {
    if ((country?.id || '') === (countryId || '')) {
      return;
    }
    onChange({
      name,
      countryId: country.id,
      nationalNumber: normalizePhoneNumber(nationalNumber, country.id)
    });
  }
}

function customSelectedValueTemplateFunction([country]) {
  return country.id || 'N/A';
}

function customOptionTemplateFunction(country) {
  if (!country.id) {
    return null;
  }
  return `${country.name} (${country.id}) ${formatDialCode(country.dialCode)}`;
}

function customFilterFunction(country, index, collection, searchString) {
  return caseInsensitiveStringIncludes(
    `${country.id} ${country.name} ${formatDialCode(country.dialCode)}`,
    searchString
  );
}
